import React from "react";

import { useEffect } from "react";

const HealthCheck: React.FC = () => {
  // On mount, immediately show the JSON response
  useEffect(() => {
    // nothing needed, just render JSON
  }, []);

  // Always return the JSON response
  return (
  
      <pre >
        {JSON.stringify({ message: "success", status: "ok" })}
      </pre>
   
  );
};

export default HealthCheck;
